<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" sm="4" md="4" lg="6">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="4" md="4" lg="6" class="text-right">
              <div>
                <v-btn-toggle v-model="toggle_exclusive" dense mandatory>
                  <v-btn @click="buildTableFormat('grouped')" ref="grouped">
                    <v-icon small left>mdi-account-group</v-icon>
                    <span> {{ $t("grouped") }}</span>
                  </v-btn>
                  <v-btn @click="buildTableFormat('list')" ref="list">
                    <v-icon small left>mdi-format-list-bulleted</v-icon>
                    <span>{{ $t("list") }}</span>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" v-if="typeList" class="d-md-none mt-3">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters class="align-center">
            <v-spacer></v-spacer>
            <v-col cols="12" sm="4" md="4" v-if="typeList">
              <div class="text-right">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'mt-3'"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>

        <div>
          <!-- ======================= -->
          <!-- FORMAT LIST (DATATABLE) -->
          <!-- ======================= -->
          <v-data-table
            :headers="headers"
            :items="dataTable"
            :items-per-page="-1"
            :search="search"
            :mobile-breakpoint="breakpoint"
            class="mb-4"
            v-if="typeList"
            :footer-props="{
              'items-per-page-text': $t('rowsPerPage'),
            }"
          >
            <template v-slot:item.regional_name="{ item }">
              <a
                class="orange--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.regional_id,
                    'colab/affiliates/getRegional'
                  )
                "
              >
                <!-- <v-icon color="orange" x-small>mdi-account-tie</v-icon> -->
                {{ item.regional_name }}
              </a>
            </template>

            <template v-slot:item.local_name="{ item }">
              <a
                class="green--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.local_id,
                    'colab/affiliates/getLocal'
                  )
                "
              >
                <!-- <v-icon color="green" x-small>mdi-account-multiple</v-icon> -->
                {{ item.local_name }}
              </a>
            </template>

            <template v-slot:item.affiliate_name="{ item }">
              <a
                class="blue--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.affiliate_id,
                    'colab/affiliates/getAffiliate'
                  )
                "
              >
                <!-- <v-icon color="primary" x-small>mdi-account</v-icon> -->
                {{ item.affiliate_name }}
              </a>
            </template>

            <!-- <template v-slot:item.affiliate_detail="{ item }">
              <div class="d-flex justify-start">
                <CasinoGameComissionsByAffiliate
                  :agent_name="item.affiliate_name"
                  :id_affiliate="item.affiliate_id"
                />
              </div>
            </template> -->

            <template v-slot:item.total_active_players="{ item }">
              <div class="caption ma-1">
                {{ item.total_active_players }} /
                {{ item.min_active_players_to_commission }}

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="d-print-none"
                    >
                      <v-icon small color="info">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $tc(
                      "usersActivesByAffiliateRemainingTooltip",
                      item.total_active_players >=
                        item.min_active_players_to_commission
                        ? 0
                        : item.min_active_players_to_commission -
                            item.total_active_players,
                      {
                        remainingUsers:
                          item.min_active_players_to_commission -
                          item.total_active_players,
                      }
                    )
                  }}</span>
                </v-tooltip>
              </div>
            </template>

            <!-- VALUES -->
            <template
              v-for="(value, index) in valueColors"
              v-slot:[`item.${value}`]="{ item }"
            >
              <span
                class="caption"
                :key="index"
                :class="
                  getColor(
                    value == 'fee_ggr_percentage'
                      ? item[value] * -1
                      : item[value]
                  )
                "
              >
                {{ addZeroes(item[value]) }}
              </span>
            </template>

            <template
              v-for="(key, index) in keysResume"
              v-slot:[`header.${key}`]="{ header }"
            >
              <span :key="key + index" class="caption">{{ header.text }}</span>
              <v-tooltip top :key="index">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="d-print-none"
                  >
                    <v-icon small color="info">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ infoKey(key) }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.affiliate_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.affiliate_commission)"
              >
                {{ addZeroes(item.affiliate_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>

            <template v-slot:item.local_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.local_commission)"
              >
                {{ addZeroes(item.local_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>

            <template v-slot:item.regional_commission="{ item }">
              <div
                v-if="item.hasMinActivePlayersToComission"
                class="caption ma-1"
                :class="getColor(item.regional_commission)"
              >
                {{ addZeroes(item.regional_commission) }}
              </div>
              <div v-else class="caption ma-1">
                <span>•••</span>
              </div>
            </template>
          </v-data-table>

          <!-- =================================== -->
          <!-- FORMAT GROUPED USERS (SIMPLE TABLE) -->
          <!-- =================================== -->
          <v-simple-table v-else>
            <thead>
              <tr>
                <th
                  v-for="(head, indexHeader) in headers"
                  :key="`${indexHeader} ${head.value}`"
                >
                  {{ head.text }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="d-print-none"
                        v-if="head.value != 'affiliate_detail'"
                      >
                        <v-icon small color="info">
                          mdi-information-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ infoKey(head.value) }}</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in data">
                <tr :key="item.regional_name" class="orange--text">
                  <td :colspan="headers.length">
                    <a
                      class="orange--text"
                      @click="
                        $profile.showProfileDrawer(
                          item.regional_id,
                          'colab/affiliates/getRegional'
                        )
                      "
                    >
                      <v-icon color="orange" small>mdi-account-tie</v-icon>
                      {{ item.regional_name }}
                    </a>
                  </td>
                </tr>

                <template v-for="(local, index) in item.locals">
                  <tr :key="local.local_name" class="green--text darken-3">
                    <td :colspan="headers.length" style="height: 40px">
                      <a
                        class="green--text ml-2"
                        @click="
                          $profile.showProfileDrawer(
                            local.id_local,
                            'colab/affiliates/getLocal'
                          )
                        "
                      >
                        <v-icon color="green" small
                          >mdi-account-multiple</v-icon
                        >
                        {{ local.local_name }}
                      </a>
                    </td>
                  </tr>
                  <tr
                    v-for="(agent, indexAgent) in local.agents"
                    :key="`${indexAgent} ${agent.affiliate_name}`"
                  >
                    <td style="width: 200px">
                      <div class="d-flex">
                        <a
                          class="blue--text ml-4"
                          @click="
                            $profile.showProfileDrawer(
                              agent.affiliate_id,
                              'colab/affiliates/getAffiliate'
                            )
                          "
                        >
                          <v-icon color="blue" small>mdi-account</v-icon>
                          {{ agent.affiliate_name }}
                        </a>
                      </div>
                    </td>
                    <td class="caption ma-1">
                      {{ agent.total_active_players }} /
                      {{ agent.min_active_players_to_commission }}

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            class="d-print-none"
                          >
                            <v-icon small color="info">
                              mdi-information-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                          $tc(
                            "usersActivesByAffiliateRemainingTooltip",
                            agent.total_active_players >=
                              agent.min_active_players_to_commission
                              ? 0
                              : agent.min_active_players_to_commission -
                                  agent.total_active_players,
                            {
                              remainingUsers:
                                agent.min_active_players_to_commission -
                                agent.total_active_players,
                            }
                          )
                        }}</span>
                      </v-tooltip>
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(item.totalRegional.gross_value)"
                    >
                      {{ addZeroes(agent.gross_value) }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.prize_value)"
                    >
                      {{ addZeroes(agent.prize_value) }}
                    </td>
                    <td class="caption ma-1" :class="getColor(agent.value_ggr)">
                      {{ addZeroes(agent.value_ggr) }}
                    </td>
                    <td
                      v-if="hasFeeValue"
                      class="caption ma-1"
                      :class="getColor(agent.fee_ggr_percentage * -1)"
                    >
                      {{ addZeroes(agent.fee_ggr_percentage) }}
                    </td>
                    <td
                      v-if="hasFeeValue"
                      class="caption ma-1"
                      :class="getColor(agent.value_ngr)"
                    >
                      {{ addZeroes(agent.value_ngr) }}
                    </td>
                    <td
                      v-if="agent.hasMinActivePlayersToComission"
                      class="caption ma-1"
                      :class="getColor(agent.affiliate_commission)"
                    >
                      {{ addZeroes(agent.affiliate_commission) }}
                    </td>
                    <td v-else class="caption ma-1">
                      <span>•••</span>
                    </td>
                    <td
                      v-if="agent.hasMinActivePlayersToComission"
                      class="caption ma-1"
                      :class="getColor(agent.local_commission)"
                    >
                      {{ addZeroes(agent.local_commission) }}
                    </td>
                    <td v-else class="caption ma-1">
                      <span>•••</span>
                    </td>
                    <td
                      v-if="agent.hasMinActivePlayersToComission"
                      class="caption ma-1"
                      :class="getColor(agent.regional_commission)"
                    >
                      {{ addZeroes(agent.regional_commission) }}
                    </td>
                    <td v-else class="caption ma-1">
                      <span>•••</span>
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.regional_commission)"
                      v-if="showAffiliateDetail"
                    >
                      <div class="d-flex justify-start">
                        <CasinoGameComissionsByAffiliate
                          :agent_name="agent.affiliate_name"
                          :id_affiliate="agent.affiliate_id"
                        />
                      </div>
                    </td>
                  </tr>
                  <!-- Total Local -->
                  <tr :key="`${local.local_name} ${index}`">
                    <td class="overline green--text ml-2">Total Local</td>
                    <td class="caption ma-1">
                      {{ local.totalLocal.total_active_players }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.gross_value)"
                    >
                      {{ local.totalLocal.gross_value }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.prize_value)"
                    >
                      {{ local.totalLocal.prize_value }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.value_ggr)"
                    >
                      {{ local.totalLocal.value_ggr }}
                    </td>
                    <td
                      v-if="hasFeeValue"
                      class="caption ma-1"
                      :class="
                        getColor(local.totalLocal.fee_ggr_percentage * -1)
                      "
                    >
                      {{ local.totalLocal.fee_ggr_percentage }}
                    </td>
                    <td
                      v-if="hasFeeValue"
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.value_ngr)"
                    >
                      {{ local.totalLocal.value_ngr }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.affiliate_commission)"
                    >
                      {{ local.totalLocal.affiliate_commission }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.local_commission)"
                    >
                      {{ local.totalLocal.local_commission }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.regional_commission)"
                    >
                      {{ local.totalLocal.regional_commission }}
                    </td>
                    <td class="caption ma-1" v-if="showAffiliateDetail"></td>
                  </tr>
                </template>
                <!-- Total regional -->
                <tr :key="`${index} ${item.regional_name}`">
                  <td class="overline orange--text">Total Regional</td>
                  <td class="caption ma-1">
                    {{ item.totalRegional.total_active_players }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.gross_value)"
                  >
                    {{ item.totalRegional.gross_value }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.prize_value)"
                  >
                    {{ item.totalRegional.prize_value }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.value_ggr)"
                  >
                    {{ item.totalRegional.value_ggr }}
                  </td>
                  <td
                    v-if="hasFeeValue"
                    class="caption ma-1"
                    :class="
                      getColor(item.totalRegional.fee_ggr_percentage * -1)
                    "
                  >
                    {{ item.totalRegional.fee_ggr_percentage }}
                  </td>
                  <td
                    v-if="hasFeeValue"
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.value_ngr)"
                  >
                    {{ item.totalRegional.value_ngr }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.affiliate_commission)"
                  >
                    {{ item.totalRegional.affiliate_commission }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.local_commission)"
                  >
                    {{ item.totalRegional.local_commission }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.regional_commission)"
                  >
                    {{ item.totalRegional.regional_commission }}
                  </td>
                  <td class="caption ma-1" v-if="showAffiliateDetail"></td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </div>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">
                        {{ TranslateKey(item) }}
                      </td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{
                          item === "qtdAgents" ||
                          item === "total_active_players"
                            ? resume[item].value
                            : addZeroes(resume[item].value)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
// import CasinoGameComissionsByAffiliate from "./CasinoGameComissionsByAffiliate";
import hasFeeValue from "@/util/hasFeeValue";

export default {
  name: "views-backoffice-collaborator-financial-colabOnlineComissions",
  components: {
    HeaderPrint,
    // CasinoGameComissionsByAffiliate,
  },
  data: () => ({
    search: "",
    breakpoint: "xs",
    data: [],
    dataTable: [],
    resume: null,
    keysResume: [],
    idRegional: "",
    idLocal: "",
    typeList: false,
    toggle_exclusive: undefined,
    headers: [],
    valueColors: [
      "gross_value",
      "prize_value",
      "value_ggr",
      "fee_ggr_percentage",
      "value_ngr",
      "affiliate_commission",
      "local_commission",
      "regional_commission",
    ],
  }),
  computed: {
    showAffiliateDetail() {
      return false;

      // if (this.$hasNewCasino()) {
      //   return false;
      // }

      // return (
      //   this.$store.state.operator.casino &&
      //   this.$store.state.operator.casino != "0" &&
      //   this.$permission("62")
      // );
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    gamingType() {
      return this.$store.state.filters.gamingType;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    hasFeeValue() {
      return hasFeeValue;
    },
    hasInvoice() {
      return this.$store.state.filters.hasInvoice.value;
    },
  },
  mounted() {
    // Table format Default;
    this.buildTableFormat("grouped");
  },
  watch: {
    saveFilters(val) {
      val && this.getComissions();
    },
  },
  methods: {
    reset() {
      this.data = [];
      this.dataTable = [];
      this.idRegional = "";
      this.idLocal = "";
    },
    async getComissions() {
      this.reset();
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
        invoice: this.hasInvoice,
      };

      if (this.$store.state.operator.casino != "0") {
        body.type = this.gamingType.value;
      } else {
        body.type = "sports";
      }

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "colab/financial/affiliatesExtract",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "colab/financial/affiliatesExtract",
          body
        );
      }

      if (!response.dados) {
        this.data = [];
        return;
      }

      try {
        this.dataTable = response.dados;
        this.dataTable.forEach((item) => {
          if (item.value_ggr < 0) {
            item.affiliate_commission = 0;
            item.local_commission = 0;
            item.regional_commission = 0;
          } else {
            item.affiliate_commission = item.affiliate_commission * -1;
            item.local_commission = item.local_commission * -1;
            item.regional_commission = item.regional_commission * -1;
          }
          item.prize_value = item.prize_value * -1;

          item.total_active_players = parseFloat(item.total_active_players);
          item.min_active_players_to_commission = parseFloat(
            item.min_active_players_to_commission
          );

          if (
            item.total_active_players >= item.min_active_players_to_commission
          ) {
            item.hasMinActivePlayersToComission = true;
          }
        });
        this.buildGroupedReport(response.dados);
        this.buildResumeData(response.dados);

        if (this.typeList) {
          this.$refs.list.$el.click();
        } else {
          this.$refs.grouped.$el.click();
        }
      } catch (error) {
        console.log(error);
      }
    },
    buildGroupedReport(dados) {
      // Fase 1
      // Reformulacao de dados trazidos da API
      // Contruindo estrutura a nível Gerente Regional
      for (let item of dados) {
        // Seto o estado inical do item do this.data
        // Esse itemData vai ser moldado com novos atributos
        // e no final vai ser adicionado no this.data responsável pela listagem
        let itemData = {};

        // Tratamento para valor das comissões
        // serem exibidas em vermelho
        // if (item.regional_commission > 0) {
        //   item.regional_commission = item.regional_commission * -1;
        // }
        // if (item.local_commission > 0) {
        //   item.local_commission = item.local_commission * -1;
        // }
        // if (item.affiliate_commission > 0) {
        //   item.affiliate_commission = item.affiliate_commission * -1;
        // }
        // if (item.prize_value > 0) {
        //   item.prize_value = item.prize_value * -1;
        // }

        // Cria as informações a nivel Ger. Regional e
        // cria um array de Ger. Locais de sua rede
        // São eles: id_regional:String, regional_name:String, locals:Array
        if (this.idRegional != item.regional_id) {
          this.idRegional = item.regional_id;
          itemData.regional_name = item.regional_name;
          itemData.regional_id = item.regional_id;
          itemData.locals = [];
        }
        // Adiciona no "Data" Array responsável pela listagem
        itemData.regional_name && this.data.push(itemData);
      }
      // Fase 2
      // Adicionando Ger. Locais da rede de cada Ger. Regional
      for (let item_data of this.data) {
        for (let data of dados) {
          if (data.regional_id == item_data.regional_id) {
            if (this.idLocal != data.local_id) {
              this.idLocal = data.local_id;
              item_data.totalRegional = {};
              item_data.locals.push({
                id_local: data.local_id,
                local_name: data.local_name,
                agents: [],
              });
            }
          }
        }
      }
      // Fase 3
      // Adicionando Agents que estão na rede de cada Ger. Local
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          for (let data of dados) {
            if (data.local_id == local_data.id_local) {
              local_data.totalLocal = {};

              const fee_ggr_percentage_calc =
                data.value_ggr * (data.affiliate_fee / 100);

              data.fee_ggr_percentage = (fee_ggr_percentage_calc > 0
                ? fee_ggr_percentage_calc
                : 0
              ).toFixed(2);

              local_data.agents.push(data);
            }
          }
        }
      }
      // Soma dos Gerentes Locais
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          let gross_value = 0,
            prize_value = 0,
            value_ggr = 0,
            fee_ggr_percentage = 0,
            value_ngr = 0,
            affiliate_commission = 0,
            local_commission = 0,
            regional_commission = 0,
            total_active_players = 0;
          for (let agent_data of local_data.agents) {
            gross_value = gross_value + Number(agent_data.gross_value);
            prize_value = prize_value + Number(agent_data.prize_value);
            value_ggr = value_ggr + Number(agent_data.value_ggr);
            fee_ggr_percentage =
              fee_ggr_percentage + Number(agent_data.fee_ggr_percentage);
            value_ngr = value_ngr + Number(agent_data.value_ngr);
            affiliate_commission =
              affiliate_commission + Number(agent_data.affiliate_commission);
            local_commission =
              local_commission + Number(agent_data.local_commission);
            regional_commission =
              regional_commission + Number(agent_data.regional_commission);
            total_active_players =
              total_active_players + Number(agent_data.total_active_players);
          }
          local_data.totalLocal.gross_value = gross_value.toFixed(2);
          local_data.totalLocal.prize_value = prize_value.toFixed(2);
          local_data.totalLocal.value_ggr = value_ggr.toFixed(2);
          local_data.totalLocal.fee_ggr_percentage = fee_ggr_percentage.toFixed(
            2
          );
          local_data.totalLocal.value_ngr = value_ngr.toFixed(2);
          local_data.totalLocal.affiliate_commission = affiliate_commission.toFixed(
            2
          );
          local_data.totalLocal.local_commission = local_commission.toFixed(2);
          local_data.totalLocal.regional_commission = regional_commission.toFixed(
            2
          );
          local_data.totalLocal.total_active_players = total_active_players;
        }
      }
      // Soma dos Gerentes Regionais
      for (let item_data of this.data) {
        let gross_value = 0,
          prize_value = 0,
          value_ggr = 0,
          fee_ggr_percentage = 0,
          value_ngr = 0,
          affiliate_commission = 0,
          local_commission = 0,
          regional_commission = 0,
          total_active_players = 0;
        for (let local_data of item_data.locals) {
          gross_value = gross_value + Number(local_data.totalLocal.gross_value);
          prize_value = prize_value + Number(local_data.totalLocal.prize_value);
          value_ggr = value_ggr + Number(local_data.totalLocal.value_ggr);
          fee_ggr_percentage =
            fee_ggr_percentage +
            Number(local_data.totalLocal.fee_ggr_percentage);
          value_ngr = value_ngr + Number(local_data.totalLocal.value_ngr);
          affiliate_commission =
            affiliate_commission +
            Number(local_data.totalLocal.affiliate_commission);
          local_commission =
            local_commission + Number(local_data.totalLocal.local_commission);
          regional_commission =
            regional_commission +
            Number(local_data.totalLocal.regional_commission);
          total_active_players =
            total_active_players +
            Number(local_data.totalLocal.total_active_players);
        }
        item_data.totalRegional.gross_value = gross_value.toFixed(2);
        item_data.totalRegional.prize_value = prize_value.toFixed(2);
        item_data.totalRegional.value_ggr = value_ggr.toFixed(2);
        item_data.totalRegional.fee_ggr_percentage = fee_ggr_percentage.toFixed(
          2
        );
        item_data.totalRegional.value_ngr = value_ngr.toFixed(2);
        item_data.totalRegional.affiliate_commission = affiliate_commission.toFixed(
          2
        );
        item_data.totalRegional.local_commission = local_commission.toFixed(2);
        item_data.totalRegional.regional_commission = regional_commission.toFixed(
          2
        );
        item_data.totalRegional.total_active_players = total_active_players;
      }
    },
    buildResumeData(data) {
      if (!data) return;
      const sum = (key) => {
        return data
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };
      let resume = {
        gross_value: {},
        prize_value: {},
        value_ggr: {},
        ...(this.hasFeeValue && {
          fee_ggr_percentage: {},
          value_ngr: {},
        }),
        affiliate_commission: {},
        local_commission: {},
        regional_commission: {},
      };
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(
          key === "fee_ggr_percentage" ? total * -1 : total
        );
      });
      const complement = {
        qtdAgents: { value: data.length },
        total_active_players: { value: Number(sum("total_active_players")) },
        gross_value: { value: Number(sum("gross_value")) },
        prize_value: { value: Number(sum("prize_value")) },
        value_ggr: { value: Number(sum("value_ggr")) },
        ...(this.hasFeeValue && {
          fee_ggr_percentage: {},
          value_ngr: { value: Number(sum("value_ngr")) },
        }),
        affiliate_commission: { value: Number(sum("affiliate_commission")) },
        local_commission: { value: Number(sum("local_commission")) },
      };
      this.resume = {
        ...complement,
        ...resume,
      };
      this.keysResume = Object.keys(this.resume);
      this.resumeExcelCopy();
    },
    resumeExcelCopy() {
      // Create String with table to Copy on Btn

      // Os espaços e indentações da String concatResume é necessária para não
      // quebrar ao copiar
      let concatResume = `
        <table>
          <tr>${this.resume.qtdAgents.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.total_active_players.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.gross_value.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.prize_value.value.toString().replace(".", ",")}</tr>
          <tr>${this.resume.value_ggr.value.toString().replace(".", ",")}</tr>`;

      if (this.hasFeeValue) {
        concatResume += `
          <tr>${this.resume.fee_ggr_percentage.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.value_ngr.value.toString().replace(".", ",")}</tr>`;
      }

      concatResume += `
          <tr>${this.resume.affiliate_commission.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.local_commission.value
            .toString()
            .replace(".", ",")}</tr>
          <tr>${this.resume.regional_commission.value
            .toString()
            .replace(".", ",")}</tr>
        `;

      concatResume += "</table>";
      this.resumePrint = concatResume;
    },
    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    buildTableFormat(format) {
      // HEADERS DEFAULT
      this.headers = [
        {
          text: this.$t("usersActivesByAffiliate"),
          value: "total_active_players",
          align: "start",
        },
        {
          text: this.$t("revenues"),
          value: "gross_value",
          align: "start",
        },
        {
          text: this.$t("awards"),
          value: "prize_value",
          align: "start",
        },
        {
          text: "GGR",
          value: "value_ggr",
          align: "start",
        },
        ...(this.hasFeeValue
          ? [
              {
                text: this.$t("feeValue"),
                value: "fee_ggr_percentage",
                align: "start",
              },
            ]
          : []),
        ...(this.hasFeeValue
          ? [
              {
                text: "NGR",
                value: "value_ngr",
                align: "start",
              },
            ]
          : []),
        {
          text: this.$t("coAffiliateBet"),
          value: "affiliate_commission",
          align: "start",
        },
        {
          text: this.$t("coGerLocal"),
          value: "local_commission",
          align: "start",
        },
        {
          text: this.$t("coRegionalManager"),
          value: "regional_commission",
          align: "start",
        },
      ];
      if (this.showAffiliateDetail) {
        this.headers.push({
          text: this.$t("actions"),
          value: "affiliate_detail",
          align: "caption",
          sortable: false,
        });
      }
      if (format === "grouped") {
        this.typeList = false;
        const users = {
          text: this.$t("affiliates"),
          value: "affiliate_name",
        };
        this.headers.unshift(users);
      }
      if (format === "list") {
        this.typeList = true;
        const users = [
          {
            text: this.$t("affiliates"),
            value: "affiliate_name",
          },
          {
            text: "Local",
            value: "local_name",
          },
          {
            text: "Regional",
            value: "regional_name",
          },
        ];
        users.forEach((item) => this.headers.unshift(item));
      }
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        qtdAgents: this.$t("qtyAffiliates"),
        total_active_players: this.$t("qtyUsersActives"),
        gross_value: this.$t("revenues"),
        prize_value: this.$t("awards"),
        value_ggr: "GGR",
        fee_ggr_percentage: this.$t("feeValue"),
        value_ngr: "NGR",
        affiliate_commission: this.$t("coAffiliateBet"),
        local_commission: this.$t("coGerLocal"),
        regional_commission: this.$t("coRegionalManager"),
      };
      return myKeysTranslated[key] || null;
    },
    infoKey: function(key) {
      const info = {
        affiliate_name: this.$t("infoAffiliateName"),
        qtdAgents: this.$t("qtyAffiliates"),
        total_active_players: this.$t("usersActivesByAffiliateExplanation"),
        regional_commission: this.$t("commissionRegionalOnGrossGGR"),
        gross_value: this.$t("valueOnSoldBets"),
        prize_value: this.$t("valueInAwards"),
        value_ggr: this.$t("ggrExplanation"),
        fee_ggr_percentage: this.$t("feeGGRPercentageExplanation"),
        value_ngr: this.$t("valueNGRExplanation"),
        affiliate_commission: this.$t("affiliateCommissionExplanation"),
        local_commission: this.$t("localCommissionExplanation"),
      };
      return info[key] || null;
    },
    addZeroes(num) {
      if (typeof num !== "string") {
        num = num.toString();
      }

      const dec = num.split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      return Number(num).toFixed(len);
    },
  },
};
</script>
